import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { RegisterPage } from '../pages/RegisterPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/register')({
  component: Register,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (isAuthenticated) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
})

function Register() {
  const navigate = useNavigate()

  const handleNavigateToLogin = () => {
    navigate({ to: '/login' })
  }

  const handleRegisterSuccess = () => {
    navigate({ to: '/dashboard' })
  }

  return (
    <RegisterPage
      onNavigateToLogin={handleNavigateToLogin}
      onRegisterSuccess={handleRegisterSuccess}
    />
  )
}